import React from "react";

import { GradientDefs } from "../../GradientDefs";

/**
 * @component DollarClockSmallIcon
 * @description
 *
 * The React Icon component is a visual element that displays an icon to represent a concept, object, or action.
 * The Icon component is
 * customizable, allowing for variations in size, color, and style to fit the needs of the application.
 *
 * @prop {string} [gradient] - Optional CSS linear-gradient string to apply a custom fill.
 * Format: "linear-gradient(<angle>deg, <color1>, <color2>, ...)"
 *
 * @example
 * return (
 * <DollarClockSmallIcon gradient="linear-gradient(135deg, #4da2ed, #f72222)" />
 * )
 *
 * @example
 * return (
 *   <DollarClockSmallIcon className="mr-2" />
 * )
 *
 * @see
 * https://system.activecollab.com/?path=/story/foundation-icons-icons--icons
 * @see
 * https://design.activecollab.com/docs/foundations/icons
 */
const DollarClockSmallIcon = React.forwardRef(
  (
    {
      gradient,
      ...props
    }: React.SVGProps<SVGSVGElement> & {
      gradient?: string;
    },
    svgRef?: React.Ref<SVGSVGElement>
  ) => (
    <svg
      width={12}
      height={12}
      viewBox="0 0 12 12"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="DollarClockSmallIcon"
      fill={
        gradient
          ? "url(#icon-gradient)"
          : props?.fill
          ? props.fill
          : "var(--color-theme-600)"
      }
      focusable={false}
      ref={svgRef}
      {...props}
    >
      <GradientDefs gradient={gradient} />
      <path
        d="M10 5v1h1v1H9v1h2v3h-1v1H9v-1H8v-1h2V9H8V6h1V5h1zM8 1v3L6 6l1 1v1.25l-2-2-2 2V10h4v1H2V8l2-2-2-2V1h6zM7 2H3v1.75l2 2 2-2V2z"
        fillRule="evenodd"
      />
    </svg>
  )
);
DollarClockSmallIcon.displayName = "DollarClockSmallIcon";
export default DollarClockSmallIcon;
